import { Navigate, useRoutes } from 'react-router-dom';
// layouts
import DashboardLayout from './layouts/dashboard';
import SimpleLayout from './layouts/simple';
//
import BlogPage from './pages/BlogPage';
import UserPage from './pages/UserPage';
import LoginPage from './pages/LoginPage';
import Page404 from './pages/Page404';
// import ProductsPage from './pages/Prod0uctsPage';
import DashboardAppPage from './pages/DashboardAppPage';
import QuizPage from './pages/QuizPage';
import ResetPassword from './pages/ResestPassword'
import ProtectedRoute from './protectedRoute';
import SignUp from './pages/SignUp'
import ForgetPasswordPage from './pages/ForgetPasswordPage'
// ----------------------------------------------------------------------

export default function Router() {
  const isLoggedIn = localStorage.getItem('token');
  const routes = useRoutes([
    {
      path: '/',
      element: <LoginPage />,
    },
    {
      path: '/dashboard',
      element: isLoggedIn ? <DashboardLayout />:<Navigate to="/login" /> ,
      children: [
        
        { element: <Navigate to="/dashboard/quiz" />, index: true },
        // { path: 'app', element: <DashboardAppPage /> },
        { path: 'user', element: <UserPage /> },
        // { path: 'products', element: <ProductsPage /> },
        // { path: 'blog', element: <BlogPage /> },
        { path: 'quiz', element: <QuizPage /> },
      ],
    },
    {
      path: '/login',
      element: <LoginPage />,
    },
    {
      path: '/sign-up',
      element: <SignUp />,
    },
    {
      path: '/forgetpassword',
      element: <ForgetPasswordPage />,
    },
    {
      path: '/resetpassword',
      element: <ResetPassword />,
    },    
    
    // {
    //   element: <SimpleLayout />,
    //   children: [
    //     // { element: <Navigate to="/login" />, index: true },
    //     { path: '404', element: <Page404 /> },
    //     { path: '*', element: <Navigate to="/404" /> },
    //   ],
    // },
    {
      path: '*',
      element: <Navigate to="/404" replace />,
    },
  ]);

  return routes;
}
